
<!--<header>-->
<!--  <div appearance="fill">-->
<!--    <select [value]="deviceSelected" (change)="onDeviceSelectChange($event)">-->
<!--      <option value="">No Device Selected</option>-->
<!--      <option *ngFor="let device of availableDevices" [value]="device.deviceId">{{device.label}}</option>-->
<!--    </select>-->
<!--  </div>-->
<!--</header>-->


<div class="containerQrPage">
  <div class="d-flex justify-content-between" style="margin-inline: 2rem">
    <img src="assets/images/synfra@4x.png" height="80" width="80">
    <img src="assets/images/Camera@4x.png" height="100" width="95">
  </div>
    <div class="qr ">
      <div style="display: flex; justify-content: center; align-items: center;">
<!--        <zxing-scanner style="
        width: 90%;
        height: 90%;
        display: flex;
    align-items: center;
    justify-content: center;
" [torch]="torchEnabled" [device]="deviceCurrent" (deviceChange)="onDeviceChange($event)" (scanSuccess)="onCodeResult($event)"
                       [formats]="formatsEnabled" [tryHarder]="tryHarder" (permissionResponse)="onHasPermission($event)" [enable]="!qrResultString"
                       (camerasFound)="onCamerasFound($event)" (torchCompatible)="onTorchCompatible($event)"></zxing-scanner>-->
      </div>
      <div class="blurred"></div>
    </div>

  <span >Inquadra il QRcode che compare sul monitor</span>
</div>


